import { PAYEE_ALPHABET, payeeHeadingId, usePayeeAlphabet } from "./use-payee-alphabet";
import { usePayeeAlphabetLayout } from "./use-payee-alphabet-layout";

export default function PayeeAlphabet({ letters }: { letters: string[] }) {
  const { nav, active, bounds, jump, start, move, end, stopClick } = usePayeeAlphabet(letters);
  const layout = usePayeeAlphabetLayout(nav);
  const position = bounds ? { top: bounds.top, left: bounds.left, width: bounds.width, height: bounds.height } : layout;
  return (
    <nav ref={nav} className="payee-alphabet" aria-label="Payee alphabet"
      style={{ ...position, fontSize: Math.min(11, position.height / PAYEE_ALPHABET.length) }}
      onPointerDown={start} onPointerMove={move} onPointerUp={end}
      onPointerCancel={event => end(event, true)} onLostPointerCapture={event => end(event, true)}
      onClickCapture={stopClick}>
      {PAYEE_ALPHABET.map(letter => letters.includes(letter) ? (
        <a key={letter} href={`#${payeeHeadingId(letter)}`} aria-label={`Jump to ${letter === "#" ? "other names" : letter}`}
          aria-current={active === letter ? "true" : undefined}
          onClick={event => { event.preventDefault(); jump(letter); }}>{letter}</a>
      ) : <span key={letter} aria-hidden="true">{letter}</span>)}
      {active && <output aria-hidden="true">{active}</output>}
    </nav>
  );
}
